import { render, staticRenderFns } from "./DashboardMonitoring.vue?vue&type=template&id=e6040708&scoped=true&"
import script from "./DashboardMonitoring.vue?vue&type=script&lang=js&"
export * from "./DashboardMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMonitoring.vue?vue&type=style&index=0&id=e6040708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6040708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
